"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "Why should I use genuine spare parts?",
    answer:
      "Genuine spare parts are intended for compatibility with the equipment they are designed or supplied for. Using the appropriate replacement components can help maintain equipment fit, performance and reliability.",
  },
  {
    question: "How do I find the correct spare part?",
    answer:
      "Start with the equipment make, model and serial number. If available, provide the existing part number as well. A photograph of the component or equipment identification plate can also help with part identification.",
  },
  {
    question: "Can I get spare parts for generators and water pumps?",
    answer:
      "Yes. Mobetts provides spare-parts support for equipment categories including generators and water pumps, subject to the specific equipment model and parts availability.",
  },
  {
    question: "What if I don't know the part number?",
    answer:
      "You can provide the equipment make, model, serial number and a clear photograph of the component or equipment identification plate. This information can help with identifying the required replacement part.",
  },
];

export default function SparePartsFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="w-full py-16 lg:py-24 px-4">
      <div className="text-center mb-12 lg:mb-16">
        <h2 className="lg:text-4xl text-2xl font-bold text-primary">
          Genuine Spare Parts FAQs
        </h2>
      </div>

      <div className="max-w-3xl mx-auto flex flex-col gap-3 lg:gap-4">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={faq.question}
              className="border border-gray-200 rounded-lg overflow-hidden bg-white"
            >
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 text-left p-5 lg:p-6"
              >
                <span className="lg:text-lg font-bold text-primary">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 flex-shrink-0 text-primary transition-transform duration-200 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`grid transition-all duration-200 ease-in-out ${
                  isOpen
                    ? "grid-rows-[1fr] opacity-100"
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="text-sm lg:text-base text-gray-600 px-5 lg:px-6 pb-5 lg:pb-6">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}